import { useEffect } from 'react';
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn';
import { useMsal } from '@azure/msal-react';
import { useHistory } from 'react-router-dom';
import PageSubTitle from '../../component/Common/PageSubTitle';
import dashboardIcon from '../../img/usa-icons/report.svg'
import reports from '../../assets/images/reports.svg'

const MainDashboard = () => {
    const { instance, accounts } = useMsal();
    const history = useHistory();
    const userType = sessionStorage.getItem('signedInUserType');

    const planPerformanceRouteFn = async () => {
        history.push('/plans-performance-dashboard');
    };

    const reviewerGroupRouteFn = async () => {
        history.push('/reviewer-groups-dashboard');
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (userType === null && (!accounts?.[0]?.localAccountId)) {
                history.push('/sign-in');
            }
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [accounts, history, userType]);

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="Reporting and Analytics" />
                </div>
            </div>

            {accounts?.[0]?.localAccountId && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
                    <div
                        onClick={planPerformanceRouteFn}
                        className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            transition: 'transform 0.2s',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                    >
                        <img src={reports} alt="lock" width="100px" className="self-start" />
                        <div className="space-y-2 mb-16 flex flex-col justify-between ml-2">
                            <p className="leading-5 mb-3 text-black">Plans Performance Excellence Scoreboard</p>
                            <div className="flex gap-2">
                                <p className="text-xs">
                                    Rating system that measures plans performance across key quality indicators
                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        onClick={reviewerGroupRouteFn}
                        className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            transition: 'transform 0.2s',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                    >
                        <img src={dashboardIcon} alt="lock" width="100px" className="self-start" />
                        <div className="space-y-2 mb-16 flex flex-col justify-between ml-2">
                            <p className="leading-5 mb-3 text-black">Internal Work Management Reporting</p>
                            <div className="flex gap-2">
                                <p className="text-xs">
                                    Presents Reviwers Groups review performance and overview of pending reviewes
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
};

export default MainDashboard;